<div class="asetukset-page">
  <div class="laskutusprofiilit">
    <div>
      @if (laskutusprofiilit().length > 1) {
        <div class="asetuskentan-otsikko">{{ 'asetukset.laskutusprofiili' | translate | async }}</div>
        <div class="laskutusprofiilin-valinta">
          <mat-button-toggle-group #laskutusprofiiliValitsin="matButtonToggleGroup" class="segmentti" [value]="valittuLaskutusprofiili()?.avain" (change)="vaihdaLaskutusprofiili($event.value, laskutusprofiiliValitsin)" [hideSingleSelectionIndicator]="true">
            @for (laskutusprofiili of laskutusprofiilit(); track laskutusprofiili.avain) {
              <mat-button-toggle [value]="laskutusprofiili.avain">{{ laskutusprofiili.nimi }}</mat-button-toggle>
            }
          </mat-button-toggle-group>
          @if (!oletusprofiiliValittu()) {
            <button mat-button type="button" (click)="poistaLaskutusprofiili()">
              <mat-icon>delete_outline</mat-icon>
              {{ 'asetukset.poista-laskutusprofiili' | translate | async }}
            </button>
          }
        </div>
      }
    </div>
    <button class="secondarybutton" mat-button type="button" (click)="lisaaLaskutusprofiili()">
      <mat-icon>add</mat-icon>
      {{ 'asetukset.lisaa-laskutusprofiili' | translate | async }}
    </button>
  </div>
  <!-- (selectedTabChange)="tabChanged($event)" -->
  <mat-tab-group [(selectedIndex)]="valittuValilehti">
    <mat-tab [label]="'asetukset.yrityksen-tiedot' | translate | async">
      <div class="sisalto">
        <app-perusasetukset #perusasetukset></app-perusasetukset>
      </div>
    </mat-tab>
    <mat-tab [label]="'asetukset.laskun-ulkoasu' | translate | async">
      <div class="sisalto">
        <app-laskuasetukset #ulkoasu osio="ulkoasu"></app-laskuasetukset>
      </div>
    </mat-tab>
    <mat-tab [label]="'asetukset.maksutilit' | translate | async">
      <div class="sisalto">
        <app-laskuasetukset #maksutilit osio="laskutusprofiilit"></app-laskuasetukset>
      </div>
    </mat-tab>
    <mat-tab [label]="'asetukset.laskutuksen-oletukset' | translate | async">
      <div class="sisalto">
        <app-laskuasetukset #oletukset osio="oletukset"></app-laskuasetukset>
      </div>
    </mat-tab>
    <mat-tab [label]="'asetukset.spostipohja' | translate | async">
      <div class="sisalto">
        <app-emailpohja #emailpohja></app-emailpohja>
      </div>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <!-- <span *ngIf="(showNewFeatureSignObservable | async)" class="uutta-sign" style="left: -29px;">{{'app.uutta' | translate | async}}</span> -->
        <div>{{ 'asetukset.reskontra' | translate | async }}</div>
      </ng-template>
      <div class="sisalto kapea">
        <app-reskontra-asetukset></app-reskontra-asetukset>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
